import { uid } from 'uid/single'

export type UidGenerator = { generate: (searchId: string) => string }

export const uidGenerator = (): UidGenerator => ({
  generate(searchId: string): string {
    const clickId = `${searchId}${uid()}`.substring(0, 23)
    return clickId
  },
})